module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0014.jpg?v=35f645d0";